"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultEnglish = exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
// These locale strings are baked into components and are expected to be imported
// and merged in the apps.

const defaultEnglish = exports.defaultEnglish = {
  'au.acct': 'Account: {acct}',
  'au.account': 'Account',
  'au.environment': 'Environment: {environment}',
  'au.dev': 'Dev',
  'au.clientId': 'Client ID',
  'au.clientSecret': 'Client Secret',
  'au.login': 'Login',
  'au.loginWithConfidentialClient': 'Login with Confidential Client',
  'au.updateMenus': 'Update Menus',
  'au.navigationBar': 'Navigation bar',
  'au.navigation.info': 'The navigation bar was successfully updated and the navigation menus are organized based on use cases.',
  'au.prod': 'Production',
  'au.production': 'PROD',
  'au.staging': 'Staging',
  'au.instance': 'Instance: {instance}',
  'au.instance.cns': 'CNS',
  'au.instance.na': 'NA',
  'au.instance.naa1': 'NA A1',
  'au.instance.sb1': 'SB1',
  'au.instance.sb1a1': 'SB1 A1',
  'au.instance.cnp0': 'CNP0',
  'au.instance.cnp0a1': 'CNP0 A1',
  'au.instance.cnp1': 'CNP1',
  'au.instance.cnp1a1': 'CNP1 A1',
  'au.support': 'Support',
  'au.devPortal': 'Dev Portal',
  'au.tmcMetrics': 'TMC Metrics',
  'au.helpCenter': 'Help Center',
  'au.serviceStatus': 'Service Status',
  'au.settings.apply': 'Apply',
  'au.on': "On",
  'au.off': "Off",
  'au.true': 'true',
  'au.false': 'false',
  'au.copy': 'Copy',
  'au.copied': 'Copied',
  'au.undo': 'Undo',
  'au.select': 'Select',
  'au.deselect': 'Deselect',
  'au.iamService': 'IAM Service',
  'au.accounts.account': 'Account',
  'au.accounts.change': 'Change',
  'au.accounts.title.selectAccount': 'Select Account',
  'au.accounts.title.changeAccount': 'Change Account',
  'au.accounts.changeAccountTo': 'Change account to',
  'au.accounts.currentAccount': 'Current Account',
  'au.accounts.saveChange': 'Save Change',
  'au.accounts.cancel': 'Cancel',
  'au.userProfile.user': 'User',
  'au.userProfile.fullName': 'Name',
  'au.userProfile.emailAddress': 'Email',
  'au.userProfile.userName': 'Username',
  'au.userProfile.token': 'Token',
  'au.userProfile.accessToken': 'Access Token',
  'au.userProfile.refreshToken': 'Refresh Token',
  'au.userProfile.copyToken': 'Copy',
  'au.userProfile.logOut': 'Return to User Login',
  'au.userProfile.change': 'Change',
  'au.userAccount.accountId': 'Account Id',
  'au.userAccount.name': 'Name',
  'au.userAccount.userAccount': 'Current Account',
  'au.userProfile.copiedToClipboard': 'Copied',
  'au.globalNavigation.close': 'close',
  'au.globalNavigation.account': 'account',
  'au.dialog.ok': 'Ok',
  'au.dialog.confirm': 'Confirm',
  'au.dialog.cancel': 'Cancel',
  'au.resultsDrawer.jsonView': 'JSON View',
  'au.resultsDrawer.loadingIndicator': 'Loading... Please wait...',
  'au.requestPermissions': 'request permissions',
  'au.collapsibleTable.collapseAll': 'Collapse All',
  'au.collapsibleTable.expandAll': 'Expand All',
  'au.jsonBox.copyClipboard': 'Copy to clipboard',
  'au.jsonBox.copied': 'Copied',
  'au.customCredentials.tab.client': 'Use My Client',
  'au.customCredentials.tab.token': 'Use My Token',
  'au.customCredentials.clientId': 'Client ID',
  'au.customCredentials.clientSecret': 'Client Secret',
  'au.customCredentials.token': 'Token',
  'au.customCredentials.requiredError': '{field} is required',
  'au.customCredentials.invalidError': '{field} is invalid',
  'au.customCredentials.login': 'Login',
  'au.customCredentials.cancel': 'Cancel',
  'au.customCredentials.clientHeader': 'Login with Confidential Client',
  'au.customCredentials.tokenHeader': 'Login with Raw Token',
  'au.table.dataFetchingMessage': "Hold on, we're fetching the data",
  'au.table.dataEmptyMessage': "Looks like there's nothing to display at the moment.",
  'au.table.filterEmptyMessage': "Looks like there's nothing matching your search filter.",
  'au.table.customNoData': 'Nothing to display',
  'au.dateRange.from': 'From',
  'au.dateRange.to': 'To',
  'au.dateRange.custom': 'Custom',
  'au.dateRange.apply': 'Apply',
  'au.dateRange.Nweeks': "{value, plural, one {# Week} other {# Weeks}}",
  'au.dateRange.Nmonths': "{value, plural, one {# Month} other {# Months}}",
  'au.dateRange.lastNhours': 'Last {value, plural, one {# hour} other {# hours}}',
  'au.dateRange.lastNdays': 'Last {value, plural, one {# day} other {# days}}',
  'au.dateRange.prevMonth': 'Previous Month',
  'au.dateRange.invalidDate': 'Please choose a valid date',
  'au.dismissAll': 'Dismiss All',
  'au.NA': 'NA',
  'au.processing': 'Processing',
  'time.duration.subHour': '{min}m {sec}s',
  'au.loadingText': 'Loading...',
  'au.updatingText': 'Updating...',
  'au.cookieBanner.mobileText': 'Our site uses cookies. By continuing to use our site you are agreeing to our',
  'au.cookieBanner.text': 'We use cookies to offer you a better experience and analyze site traffic. By continuing to use this website, you consent to the use of cookies in accordance with our',
  'au.cookieBanner.privacyPolicy': 'privacy policy',
  'au.cookieBanner.accept': 'Accept',
  'au.goBack': 'Go Back',
  'au.error.generic': 'There was an error processing your request.',
  'au.error.title': 'Oops! Something went wrong',
  'au.error.apology': 'We apologize for the inconvenience.',
  'au.errors.help': 'Please try again later.',
  'au.errors.suggestion': 'Suggested Resources',
  'au.errors.serviceStatus': 'Service Status',
  'au.errors.troubleshooting': 'TroubleShooting',
  'au.errors.support': 'Support',
  'au.errors.iamService': 'IAM Service',
  'au.errors.tmcInstances': 'TMC Instances',
  'au.errors.400.title': 'Bad Request',
  'au.errors.400.message': 'Sorry, we could not understand your request due to invalid syntax.',
  'au.errors.400.help': 'Please verify the identifier or environment. You can also attempt to refresh the page or try again later.',
  'au.errors.401.title': 'Unauthorized',
  'au.errors.401.message': 'Sorry, looks like you were logged out. Please refresh the page.',
  'au.errors.401.help': 'Please refresh your token or refresh the page',
  'au.errors.403.title': 'Forbidden',
  'au.errors.403.message': 'Sorry, access to this page is denied.',
  'au.errors.403.help': 'Please check that you have the correct permissions or {link}.',
  'au.errors.404.title': 'Not Found',
  'au.errors.404.message': 'Sorry, we could not find the page you requested.',
  'au.errors.404.help': 'Please verify the client environment and permissions. For more information about access management, see {iamLink}.',
  'au.errors.405.title': 'Not Allowed',
  'au.errors.405.message': 'Sorry, we are unable to complete the requested action.',
  'au.errors.405.help': 'Please check that the target resource supports this method.',
  'au.errors.408.title': 'Request Timeout',
  'au.errors.408.message': 'Sorry, we are unable to complete the requested action.',
  'au.errors.409.title': 'Conflict',
  'au.errors.409.message': 'Sorry, we are unable to complete the requested action.',
  'au.errors.409.help': 'Please check that you have entered the correct information or url.',
  'au.errors.410.help': 'Please contact {email} for more information.',
  'au.errors.415.help': 'Please use a supported format or file type.',
  'au.errors.422.title': 'Unprocessable Content',
  'au.errors.422.help': 'Please double-check your input and ensure it adheres to the expected format.',
  'au.errors.500.title': 'Internal Server Error',
  'au.errors.500.message': 'Sorry, there is a problem occured while processing your request.',
  'au.errors.500.help': 'You can try refreshing the page, try again later, or contact the TMC team at {emailLink}',
  'au.errors.502.title': 'Internal Server Error',
  'au.errors.502.message': 'Sorry, there is a problem occured while processing your request.',
  'au.errors.503.title': 'Service Unavailable',
  'au.errors.503.message': 'Sorry, the service you are trying to reach is currently unavailable.',
  'au.errors.503.help': 'Please try again later.',
  'au.errors.504.title': 'Gateway Timeout',
  'au.errors.504.message': 'Sorry, the service you are trying to reach is not responding.',
  'au.errors.504.help': 'You can try refreshing the page, try again later, or contact the TMC team at {email}',
  'au.errors.clientSide.title': 'Check Engine',
  'au.errors.clientSide.code': 'UH 0H',
  'au.errors.clientSide.message': 'An unexpected problem has occurred. We\'ve logged it and will fix it as soon as we can.',
  'au.legal.allRightsReserved': '© {year} Ford Motor Company. All Rights Reserved.',
  'au.legal.confidential': 'Confidential',
  'au.legal.privacyPolicy': 'Privacy',
  'au.legal.security': 'Security',
  'au.security.certifiedSecurity': 'TMC Certified Security',
  'au.security.commitment': 'TMC is committed to delivering the highest level of security for our customers. As a testament to this commitment, we have achieved both SOC 2 and ISO 27001 certifications, demonstrating adherence to rigorous security standards.',
  'au.security.certificate': "TMC is committed to safeguarding your data and the TMC platform. We've achieved both ISO 27001 and SOC 2 Type 2 certifications, demonstrating our adherence to comprehensive security frameworks. ISO 27001 ensures the implementation of a robust Information Security Management System (ISMS), while SOC 2 Type 2 provides independent assurance of our controls over security and availability. These certifications offer independent verification of our commitment to security excellence.",
  'au.security.viewCertificate': 'View Certificate',
  'au.actions': 'Actions',
  'au.domainbootstrap.title': 'Sign In',
  'au.domainbootstrap.msg': 'Enter your email domain to begin',
  'au.domainbootstrap.placeholder': 'Ex. ford.com',
  'au.domainbootstrap.enter': 'Next',
  'au.domainbootstrap.retrieveError': 'Please enter a valid email domain (ex. ford.com)',
  'au.copyright': '© {year} Ford Motor Company. All rights reserved.',
  'au.sidebarFilters.filters': 'Filters',
  'au.sidebarFilters.reset': 'Reset',
  'au.filterSegment.clear': 'Clear',
  'au.jsonEditor.undo': 'Undo',
  'au.jsonEditor.redo': 'Redo',
  'au.jsonEditor.beautify': 'Beautify',
  'au.jsonEditor.maximize': 'Maximize',
  'au.jsonEditor.minimize': 'Minimize',
  'au.tmcLookup.ftcpEvent': 'Type: Alert ({count})',
  'au.tmcLookup.searchPlaceholder': 'Type',
  'au.tmcLookup.noResults': 'No results found, please try another value',
  'au.v1': 'v1',
  'au.v2': 'v2 (Based on use cases)'
};
const defaultChinese = {
  'au.globalNavigation.menu': '菜单',
  'au.globalNavigation.account': '账号',
  'au.globalNavigation.close': '关闭',
  'au.userProfile.userProfile': '个人信息',
  'au.userProfile.fullName': '姓名',
  'au.userProfile.emailAddress': '邮箱地址',
  'au.userProfile.tokens': '令牌',
  'au.userProfile.accessToken': '访问令牌',
  'au.userProfile.copyToken': '复制',
  'au.userProfile.refreshToken': '更新令牌',
  'au.userProfile.logOut': '登出',
  'au.userProfile.copiedToClipboard': '已复制',
  'au.cookieBanner.text': '本网站使用 cookies 来提供优质的用户体验并分析网站流量。如果您继续浏览，本网站默认您同意我们使用 cookies 并接受我们的',
  'au.cookieBanner.privacyPolicy': '隐私政策',
  'au.cookieBanner.mobileText': '本网站使用 cookies。如果您继续浏览，本网站默认您同意我们的',
  'au.cookieBanner.accept': '接受',
  'au.dialog.confirm': '确认',
  'au.dialog.cancel': '取消',
  'au.table.dataFetchingMessage': "请稍等，获取数据中......",
  'au.table.dataEmptyMessage': "当前没有可显示的信息。",
  'au.table.filterEmptyMessage': "当前没有与搜索条件匹配的结果。",
  'au.dateRange.from': '从',
  'au.dateRange.to': '至',
  'au.dateRange.custom': '自定义',
  'au.dateRange.apply': '应用',
  'au.dateRange.Nweeks': "{value, plural, one {# Week} other {# Weeks}} 周",
  'au.dateRange.Nmonths': "{value, plural, one {# Month} other {# Months}} 月",
  'au.dateRange.lastNhours': '过去 {value, plural, one {# hour} other {# hours}} 小时',
  'au.dateRange.lastNdays': '过去 {value, plural, one {# day} other {# days}} 天',
  'au.dateRange.prevMonth': '上一个月',
  'au.dateRange.invalidDate': '请选择有效日期',
  'au.NA': '不可用',
  'time.duration.subHour': '{min}分 {sec}秒',
  'au.loadingText': '更新中......',
  'au.goBack': '返回',
  'au.error.generic': '处理您的请求时出错。',
  'au.errors.400.title': '请求无效',
  'au.errors.400.message': '抱歉，语法错误导致我们无法处理您的请求。',
  'au.errors.401.title': '未授权',
  'au.errors.401.message': '抱歉，您已登出。请刷新页面。',
  'au.errors.403.title': '禁止访问',
  'au.errors.403.message': '抱歉，您无权访问该页面。',
  'au.errors.404.title': '您所访问的页面不存在',
  'au.errors.404.message': '抱歉，无法找到您请求的页面。',
  'au.errors.500.title': '内部服务器错误',
  'au.errors.500.message': '抱歉，处理您的请求时出错。',
  'au.errors.503.title': '服务不可用',
  'au.errors.503.message': '抱歉，您要获取的服务当前不可用。',
  'au.errors.clientSide.title': '客户端问题',
  'au.errors.clientSide.code': '似乎出错了',
  'au.errors.clientSide.message': '发生意外错误，我们已记录此问题并将尽快处理。'
};
var _default = exports.default = {
  en: defaultEnglish,
  'en-GB': (0, _assign.default)({}, defaultEnglish, {}),
  zh: (0, _assign.default)({}, defaultEnglish, defaultChinese)
};